'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _express = require('express');

var _minimajs = require('minimajs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The RestHandler template of a plugin.
 * 
 * @export
 * @class PluginRestServiceHandler
 */
var PluginRestServiceHandler = function () {
    /**
     * Creates an instance of PluginRestServiceHandler.
     * 
     * @param {Plugin} plugin 
     * @memberof PluginRestServiceHandler
     */
    function PluginRestServiceHandler(plugin) {
        (0, _classCallCheck3.default)(this, PluginRestServiceHandler);

        this.plugin = plugin;
    }

    /**
     * Handle a REST request.
     * 
     * @param {Request} request 
     * @param {Response} response 
     * @memberof PluginRestServiceHandler
     */


    (0, _createClass3.default)(PluginRestServiceHandler, [{
        key: 'handle',
        value: function handle(request, response) {
            var id = request.params.id;
            var body = request.body;
            response.json({ body: body });
        }
    }]);
    return PluginRestServiceHandler;
}();

exports.default = PluginRestServiceHandler;
//# sourceMappingURL=PluginRestServiceHandler.js.map